import { Auth0Role } from '@gr/shared/models';
import axios from 'axios';
import { addMinutes, roundToNearestMinutes } from 'date-fns';
import { splitCsvRows } from './validation.provider';

export const getUtcDateStringNoTime = (date: Date): string => {
  return date ? new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`).toISOString() : '';
};

export const roundToNextQuarterHour = (date: Date): Date => {
  const nearest = roundToNearestMinutes(date, { nearestTo: 15 });

  return date > nearest ? roundToNearestMinutes(addMinutes(date, 10), { nearestTo: 15 }) : nearest;
};

export const convertEnumToReadableString = (myEnum: any): string => {
  return myEnum
    .split('_')
    .map((fragment: string) => fragment.charAt(0).toLocaleUpperCase() + fragment.slice(1).toLocaleLowerCase())
    .join(' ');
};

export const getApiErrorMessage = (error: unknown, fallbackMessage: string): string => {
  if (!axios.isAxiosError<{ message?: string }>(error)) {
    return fallbackMessage;
  }

  return error.response?.data?.message || fallbackMessage;
};

export const getReadableRoleName = (role: Auth0Role): string => {
  return convertEnumToReadableString(role)
    ?.replace('Gr ', 'GR ')
    ?.replace('P2p ', 'P2P ')
    ?? 'N/A';
};

export const downloadFileFromUrl = (fileUrl: string) => {
  const downloadAnchor = document.createElement('a');

  downloadAnchor.href = fileUrl;
  downloadAnchor.download = fileUrl.split('/').pop() ?? '';
  downloadAnchor.target = '_blank';

  document.body.appendChild(downloadAnchor);
  downloadAnchor.click();
  document.body.removeChild(downloadAnchor);
};

export const getCsvRecords = (file: File): Promise<string[]> => {
  return new Promise((resolve, reject) => {
    if (file && file.name.endsWith('.csv')) {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        const buffer = event?.target?.result;

        const encoder = new TextDecoder('utf-8');

        const csvContent = encoder.decode(buffer as ArrayBuffer);

        const content = splitCsvRows(csvContent)
          .map(cell => cell.replace(/[\r\n]/g, ''))
          .filter((record) => record.replace(/^[\s,]+$/g, '')); // Remove empty rows and rows with empty data

        content.shift(); // Remove the headers

        resolve(content);
      };

      reader.onerror = () => {
        reader.abort();
        reject(new DOMException('Error when attempting to parse the file'));
      };

      reader.readAsArrayBuffer(file);
    }
  });
};

export const toPhoneNumberFormat = (phoneNumber: string): string => {
  if (phoneNumber.startsWith('+1')) {
    phoneNumber = phoneNumber.substring(2);
  }

  const firstSegment = `(${phoneNumber.substring(0, 3)})`;

  const secondSegment = phoneNumber.substring(3, 6);
  const thirdSegment = phoneNumber.substring(6);

  return `${firstSegment} ${secondSegment}-${thirdSegment}`;
};


export function orderStringAscending<T>(key: string) {
  return (a: T, b: T) => (a[key].toLowerCase() < b[key].toLowerCase() ? -1 : 1);
}
